import { render, staticRenderFns } from "./PeopleFilter.vue?vue&type=template&id=977f84a4&scoped=true"
import script from "./PeopleFilter.vue?vue&type=script&lang=js"
export * from "./PeopleFilter.vue?vue&type=script&lang=js"
import style0 from "./PeopleFilter.vue?vue&type=style&index=0&id=977f84a4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977f84a4",
  null
  
)

export default component.exports